import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { CoursesContent } from "../DTOs/responses/courses";

type CoursesResponse = AxiosResponse<CoursesContent>;

export const useCourses = (): UseQueryResult<CoursesContent> => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchCourses = (): Promise<CoursesResponse> => {
    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(`${process.env.REACT_APP_BASE_URL}/courses`, {
      headers,
    });
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["courses-get", language],
    queryFn: fetchCourses,
    select: (data) => data.data,
  });
};

export const useCourseDetails = (courseId?: string) => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchCourseDetails = () => {
    if (!courseId) {
      throw new Error("courseId is undefined");
    }

    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(
      `${process.env.REACT_APP_BASE_URL}/courses/details/${courseId}`,
      {
        headers,
      },
    );
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["course-full-details", courseId, language],
    queryFn: fetchCourseDetails,
    select: (data) => data.data,
  });
};
